<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Añadir agente
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true }
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Tipo -->
              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="extensión"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :disabled="isLoading"
                    v-model="extension"
                    :items="extesionItems"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-tag"
                    label="Extensión"
                    filled
                    rounded
                  ></v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            Conectar
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";

export default {
  components: {
    vuescroll
  },

  props: {
    isActive: {
      type: Boolean
    },
    queue: {
      type: String
    }
  },

  data() {
    return {
      isLoading: false,
      extesionItems: [],
      extension: ""
    };
  },

  created() {
    this.getExtension();
    // console.log(this.queue);
  },

  methods: {
    resetform() {
      this.extesionItems = [];
      this.payload.type = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async getExtension() {
      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/clients/listExtensionAll`, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
        .then((res) => {
          this.extesionItems = res.data;
          // this.extesionItems.unshift("Variable");
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error(
            "No se pudo obtener listado de extensiones.",
            "¡Error!"
          );
        })
        .finally(() => {
          this.isLoadingExtensionItems = false;
        });
    },

    async submitForm() {
      this.isLoading = true;

      const payload = {
        queue: this.queue,
        status: 1,
        extension: this.extension
      };

      try {
        const { data } = await PbxHttpClient.post(
          "/admin/connect_extension",
          payload
        );

        this.$snotify.success(`${data[0].message}`, `Cola ${data[0].queue}`);

        this.closeDialog();
      } catch (err) {
        this.$snotify.error(err.response?.data?.error, "¡Error!");
        this.isLoading = false;
      }
    }
  }
};
</script>
